{
  "menu": {
    "description": "Coach menu",
    "items": [
      {
        "index": 0,
        "route": "content/coach/dashboard",
        "label": "DASHBOARD_COACH",
        "icon": "arrow_forward"
      }
    ]
  }
}
